import "@/i18n/config";
import { Button } from "@nextui-org/button";
import { Popover, PopoverContent, PopoverTrigger } from "@nextui-org/popover";
import React, { useEffect, useState } from "react";
import SVG from "react-inlinesvg";

import CommentIcon from "@assets/icons/comment.svg";

import { getComments } from "@/client_app/components/CommunityMemberDetails/services/FetchAPIService";
import { Tagger } from "@/client_app/components/CommunityMemberDetails/TabSection";
import { CommentContent } from "@/common/components/CommentContent";

export interface Prop {
  recordId: string;
  recordType: string;
  title?: string;
  inAdmin?: boolean;
  taggers: Tagger[];
}

export function Comment({
  recordId,
  recordType,
  inAdmin,
  title,
  taggers,
}: Prop) {
  const [nbComments, setNbComments] = useState(0);
  const [comments, setComments] = useState([]);
  const [recordName, setRecordName] = useState("");

  useEffect(() => {
    if (recordId) {
      getComments({ recordId, recordType, inAdmin })
        .then((response) => response.json())
        .then((data) => {
          const firstKey = Object.keys(data.comments || {})[0];
          const length = data.comments?.[firstKey]?.length || 0;
          setNbComments(length);
          setRecordName(firstKey);
          setComments(data.comments);
        });
    }
  }, [recordId, recordType]);

  return (
    <Popover placement='right' showArrow>
      <PopoverTrigger>
        <Button>
          <SVG
            src={CommentIcon}
            className='icon fill-current mr-4 cursor-pointer'
          />
          <span className='ml-[-12px]'>{nbComments > 0 && nbComments}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className='bg-white border-neutral-200 border rounded-lg min-w-[400px] shadow flex flex-row justify-start'>
        <CommentContent
          title={title}
          taggers={taggers}
          recordId={recordId}
          recordType={recordType}
          inAdmin={inAdmin}
          onNbCommentChange={(number) => setNbComments(number)}
          defaultComments={comments}
          recordName={recordName}
        />
      </PopoverContent>
    </Popover>
  );
}
